import { ICenterBase } from '../center-base';
import { IListItem } from '../list-item';
import { IDonorProfileAdpRecipient } from './adp-recipient';

export interface IDonorProfileAdminDonorData {
    centerId: number,
    originalRecipientId: number,
    isAdp: boolean,
    registrationDate: string,
    isDeleted: boolean,
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    matchStatus: number,
    alias: string,
    nddStatus: number,
    isInDonorFollowup: boolean,
    isHardToMatch: boolean,
    hasSamplesAtViracor: boolean,
    isRemoteDirect: boolean,
    isInternalDirect: boolean,
    sendComplianceEmails: boolean,
    hasCtScanOnline: boolean,
    lastCryoOrder: string,
    donationType: number,
    canOrderCryo: boolean
}

export interface IDonorProfileAdminLookupData {    
    centerList: ICenterBase[],
    adpRecipientList: IDonorProfileAdpRecipient[],
    chainNumberList: number[],
    clusterNumberList: number[],
    positionNumberList: number[],
    matchStatusList: IListItem[],
    nddStatusList: IListItem[],
    donationTypeList: IListItem[]
}